import React, {ReactElement, Fragment} from 'react';

import classNames from 'classnames';

import {Price} from 'components/price/price';

import s from './accessoryPrice.scss';

type PropsType = {
    price: string;
    specialPrice: string;
};

/**
 * Component for accessory base price with discount if needed
 * @param {PropsType} props for accessory prices
 * @returns {ReactElement} accessory price component
 */
export const AccessoryPrice = ({price, specialPrice}: PropsType): ReactElement => {
    const isDiscounted = specialPrice && Number(price) !== Number(specialPrice);

    return (
        <Fragment>
            <span className={classNames({[s.initialPrice]: isDiscounted})}>
                <Price>{price}</Price>
            </span>
            {isDiscounted && (
                <span className={s.specialPrice}>
                    <Price>{specialPrice}</Price>
                </span>
            )}
        </Fragment>
    );
};
